import { CheckIcon, ContentCopy } from 'components/icons';
import { t } from 'utils/getTranslations';

/**
 * What a copy button says to a screen reader: "Copied!" while `copied` holds, "Could not copy" while `failed` does. It
 * sits beside the button, never in it, where it would join the button's name, and is mounted with it: a live region
 * that arrives with its words is not reliably read.
 */
export function CopiedStatus({ copied, failed = false }: { copied: boolean; failed?: boolean }) {
    return (
        <span role="status" className="sr-only">
            {copied ? t('copied-to-clipboard') : null}
            {failed ? t('copy-to-clipboard-failed') : null}
        </span>
    );
}

/**
 * A copy button's glyph, a check for a moment after the copy. It leads the label where the button has one, and the
 * kit's button pads that side for it. The glyphs are blocks: inline, each would sit on its box's text baseline, below
 * the button's centre.
 */
export function CopyGlyph({ copied }: { copied: boolean }) {
    return (
        <span className="t-icon-swap" data-icon="inline-start" data-state={copied ? 'b' : 'a'} aria-hidden="true">
            <span className="t-icon" data-icon="a">
                <ContentCopy className="block size-4" />
            </span>
            <span className="t-icon text-success-ink" data-icon="b">
                <CheckIcon className="block size-4" />
            </span>
        </span>
    );
}
